export enum GroupTypes {
    IMPLICIT,
    CUSTOM,
}
